import React from "react";
import { Select } from "antd";
import { filterBoreOption } from "../../utilities/fulcrumData";

const Option = Select.Option;

// Fields already visible in the option label; everything else only shows in
// the secondary "matched on" line when a search token hits it.
const LABEL_FIELDS = ["Job number", "Client job"];

function tokenize(input) {
  return input.toLowerCase().split(/\s+/).filter(Boolean);
}

function highlightMatches(text, tokens) {
  if (!text || tokens.length === 0) {
    return text;
  }
  const pattern = tokens
    .map((t) => t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"))
    .join("|");
  const parts = String(text).split(new RegExp(`(${pattern})`, "gi"));
  // Odd indices are the captured matches.
  return parts.map((part, i) => (i % 2 === 1 ? <b key={i}>{part}</b> : part));
}

// Owns the search text so keystrokes only re-render this Select, not the
// whole Bores page with its tables.
class BoreSelect extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { search: "" };
  }

  handleChange = (projectId) => {
    this.setState({ search: "" });
    this.props.onChange(projectId);
  };

  handleDropdownVisibleChange = (open) => {
    if (!open) {
      this.setState({ search: "" });
    }
  };

  renderOptionContent(x, tokens) {
    // Options that fail the filter never show, so skip the highlight work.
    if (
      tokens.length === 0 ||
      !tokens.every((t) => x.searchText.includes(t))
    ) {
      return x.label;
    }

    const matchedHiddenFields = [];
    for (const [name, value] of Object.entries(x.searchFields)) {
      if (LABEL_FIELDS.includes(name) || !value) {
        continue;
      }
      const haystack = String(value).toLowerCase();
      if (tokens.some((t) => haystack.includes(t))) {
        matchedHiddenFields.push([name, value]);
      }
    }

    return (
      <div>
        <div>{highlightMatches(x.label, tokens)}</div>
        {matchedHiddenFields.length !== 0 && (
          <div style={{ fontSize: 12, color: "#888", whiteSpace: "normal" }}>
            {matchedHiddenFields.map(([name, value], i) => (
              <span key={name}>
                {i > 0 && " · "}
                {name}: {highlightMatches(String(value), tokens)}
              </span>
            ))}
          </div>
        )}
      </div>
    );
  }

  render() {
    const tokens = tokenize(this.state.search);
    return (
      <Select
        showSearch
        placeholder="Search by job number, client job, title, location, driller..."
        style={{ width: "100%", paddingBottom: 10 }}
        onChange={this.handleChange}
        onSearch={(value) => this.setState({ search: value })}
        onDropdownVisibleChange={this.handleDropdownVisibleChange}
        filterOption={filterBoreOption}
        optionLabelProp="title"
      >
        {this.props.boreList.map((x) => (
          <Option
            key={x.projectId + x.jobNumber}
            value={x.projectId}
            title={x.label}
            data-search={x.searchText}
          >
            {this.renderOptionContent(x, tokens)}
          </Option>
        ))}
      </Select>
    );
  }
}

export default BoreSelect;
